"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "valbrevenna": {
    "ea79dde4": [{
      "hkey": "a14bdac4",
      "slug": "molino-vecchio-scapitola-baio",
      "name": "Molino Vecchio-Scapitola-Baio",
      "primary": true,
      "skipSearch": false
    }],
    "molino-vecchio": [{
      "hkey": "a14bdac4",
      "slug": "molino-vecchio-scapitola-baio",
      "name": "Molino Vecchio-Scapitola-Baio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;